// extracted by mini-css-extract-plugin
export default {"OrderItemAddedSauce":"OrderItemAddedSauce_OrderItemAddedSauce__2eL0P","OrderItemAddedSauce__gift":"OrderItemAddedSauce_OrderItemAddedSauce__gift__3TSMn"};